import { render, staticRenderFns } from "./OrderInfoItem.vue?vue&type=template&id=135df8c2&scoped=true"
import script from "./OrderInfoItem.vue?vue&type=script&lang=js"
export * from "./OrderInfoItem.vue?vue&type=script&lang=js"
import style0 from "./OrderInfoItem.vue?vue&type=style&index=0&id=135df8c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135df8c2",
  null
  
)

export default component.exports